import { useCallback } from 'react'

import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const IS_RECAPTCHA_ENABLED = process.env.REACT_APP_ENVIRONMENT === 'production'
const RECAPTCHA_ERROR = 'Recaptcha token missing or invalid. Try again.'

export const useRecaptchaSubmit = ({ action, handleSubmit, onSubmit, setError, setValue }) => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  return useCallback(async (event) => {
    event.preventDefault()

    try {
      if (IS_RECAPTCHA_ENABLED) {
        if (!executeRecaptcha) {
          setError('recaptchaToken', { type: 'manual', message: RECAPTCHA_ERROR })
          return
        }

        const token = await executeRecaptcha(action)
        setValue('recaptchaToken', token)
      }
    } catch (error) {
      setError('recaptchaToken', { type: 'manual', message: RECAPTCHA_ERROR })
      return
    }

    handleSubmit(onSubmit)()
  }, [action, executeRecaptcha, handleSubmit, onSubmit, setError, setValue])
}
